'use client';

import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';

import { generateLink } from '@/helpers/common';
import { ScBonusReceivedTooltip } from './styled';

const ACTIVE_BONUSES_TAB = 'active-bonuses';

export const BonusReceivedTooltip = () => {
  const { t, i18n } = useTranslation('common');

  const href = `${generateLink('/promotions', i18n.language)}?tab=${ACTIVE_BONUSES_TAB}`;

  return (
    <ScBonusReceivedTooltip>
      <strong className="title">{t('bonusReceived.title')}</strong>
      <p className="text">
        <Trans
          components={{ l: <Link className="link" href={href} /> }}
          i18nKey="bonusReceived.text"
          ns="common"
        />
      </p>
    </ScBonusReceivedTooltip>
  );
};
